import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=4da56aec&scoped=true"
import script from "./UsersPage.vue?vue&type=script&lang=ts"
export * from "./UsersPage.vue?vue&type=script&lang=ts"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=4da56aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da56aec",
  null
  
)

export default component.exports